<div class="flex">
  <div [@openClose]="isToggleSearch ? 'open' : 'closed'">
    <p-dropdown [options]="parameterGroups" optionLabel="groupName" [(ngModel)]="currentParameterGroup"
      (onChange)="parameterGroupDDLChange($event)" placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
      [filter]="true" filterBy="groupName" [showClear]="true" [disabled]="isPreferenceLoading"></p-dropdown>
  </div>
  <button pButton pRipple class="ml-2 p-button-rounded p-button-text" icon="fas fa-search"
    (click)="toggleSearch($event)" [disabled]="isPreferenceLoading"></button>
  <button pButton pRipple class="ml-2 p-button-rounded p-button-text"
    [icon]="isPreferenceLoading ? 'fas fa-spinner fa-spin' : (isToggleBookmark ? 'fas fa-bookmark' : 'far fa-bookmark')"
    (click)="toggleBookmark($event)" [disabled]="isPreferenceLoading"></button>
  <button *ngIf="currentParameterGroup" pButton pRipple class="ml-2 p-button-rounded p-button-text" icon="fas fa-save"
    (click)="saveBtnClick($event)" [disabled]="isPreferenceLoading"></button>
  <p-overlayPanel #groupInfo appendTo="body">
    <ng-template pTemplate>
      <form [formGroup]="form" class="grid">
        <div class="col">
          <input formControlName="parameterGroupName" pInputText type="text" [(ngModel)]="newParameterGroupName" />
          <div *ngIf="form.controls.parameterGroupName.invalid && (submitted || (form.controls.parameterGroupName.dirty))">
            <small
            *ngIf="form.controls.parameterGroupName.errors?.required"
            class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
          </div>
        </div>
        <div class="col">
          <button pButton class="ml-2" label="{{ 'Common.Button.Save' | translate }}"
            (click)="groupInfoSaveBtnClick($event)" [disabled]="isPreferenceLoading"></button>
        </div>
      </form>
    </ng-template>
  </p-overlayPanel>
</div>
<p-confirmPopup></p-confirmPopup>
